<template>
  <div class="select-type-container">
    <div class="brand-bg-container c:row-center">
      <img :src="brandInfo.image" alt="" />
      <div class="ca-avatar">
        <img :src="user.caAvatar" alt="" />
      </div>
    </div>
    <div class="select-type-sa-info">
      <p class="sa-name">{{ user.name }}</p>
      <p class="store-name">{{ user.storeName || "-" }}</p>
    </div>
    <div class="input-item">
      <div class="input-item-label">
        {{ customerInfo.isTrueName ? "客人姓名" : "微信昵称" }}
      </div>
      <input
        disabled
        :value="customerInfo.nickname || '-'"
        class="no-common-ligatures"
        type="text"
      />
    </div>
    <div class="input-item">
      <div class="input-item-label"><span class="required">订单类型</span></div>
      <CSelect
        large
        title="请选择"
        :options="orderTypes"
        v-model="selectTypeIndex"
      ></CSelect>
    </div>
    <div class="next-step-container">
      <van-button
        type="primary"
        @click="onClickNext"
        :disabled="selectTypeIndex === undefined"
        class="next-step-button"
        >下一步</van-button
      >
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import {
  useDefaultWeWorkAgentConfig,
  getCurExternalContact,
} from "@/utils/wechat";
import { getOrderTypeEnumsApi } from "@/api";
import CSelect from "@/components/common/CSelect.vue";
import Config from "@/config";
export default {
  data() {
    return {
      orderTypes: [],
      selectTypeIndex: undefined,
      userId: "",
    };
  },
  components: {
    CSelect,
  },
  computed: {
    ...mapState(["user", "customerInfo", "brandInfo"]),
    ...mapGetters(["isSalerAccount"]),
  },
  created() {
    this.clearCustomerInfo();
    this.init();
  },
  methods: {
    ...mapActions(["getCustomerInfo"]),
    ...mapMutations(["clearCustomerInfo"]),
    init() {
      if (this.brandInfo.deposit?.enabled === false) {
        return this.$router.replace({
          path: `/sa/create-order?orderType=1`,
        });
      }
      let that = this;
      if (this.user.name && !this.isSalerAccount) {
        that.$dialog
          .alert({
            title: "提示",
            message: "仅SA可以进行下单，请确认权限",
          })
          .then(() => {
            that.$router.replace({
              path: "/",
            });
          });
      }
      this.$toast.loading({
        message: "",
        forbidClick: true,
      });
      useDefaultWeWorkAgentConfig()
        .then(() => {
          return getCurExternalContact();
        })
        .then((res) => {
          this.userId = res.userId;
          return this.getUserInfoAndCheckRegistered();
        })
        .finally(() => {
          this.$toast.clear();
        });
      // 开发用
      if (Config.isDevelopment) {
        this.userId = "wmNf8SEwAA5loYI9oq0pHqLGAuH_H_cQ";
        this.getUserInfoAndCheckRegistered();
      }
      getOrderTypeEnumsApi().then((data) => {
        this.orderTypes = data.map((item) => ({
          label: item.desc,
          value: item.code,
        }));
      });
    },
    getUserInfoAndCheckRegistered() {
      if (!this.isSalerAccount) return Promise.reject("非SA账号");
      return this.$store
        .dispatch("getCustomerInfo", { userId: this.userId })
        .then(() => {
          return this.checkCustomerIsRegistered();
        });
    },
    async checkCustomerIsRegistered() {
      if (
        this.brandInfo.cdbQuery?.enabled &&
        this.customerInfo.inCDB === false
      ) {
        try {
          await this.$dialog.confirm({
            title: "客人尚未注册或绑定",
            message: this.brandInfo.cdbQuery.popupText,
            confirmButtonText: "发送注册链接",
            cancelButtonText: "继续下单",
          });
          wx.invoke(
            "sendChatMessage",
            {
              msgtype: "miniprogram",
              enterChat: false,
              miniprogram: {
                appid: this.brandInfo.cdbQuery.mpAppid,
                title: `您的${this.brandInfo.brandName}客户顾问向您发送了注册链接`,
                imgUrl: this.brandInfo.cdbQuery.mpCover,
                page: this.brandInfo.cdbQuery.mpPath,
              },
            },
            (res) => {
              console.log("sendChatMessage-res", res);
              if (res.err_msg == "sendChatMessage:ok") {
                this.$toast("发送成功");
                this.sendComplete = true;
              }
            }
          );
        } catch (error) {
          if (error?.message) this.$toast(error.message);
        }
      }
    },
    onClickNext() {
      this.$router.push({
        path: `/sa/create-order`,
        query: {
          orderType: this.orderTypes[this.selectTypeIndex].value,
          userId: this.userId,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.brand-bg-container {
  background-color: #fff;
  object-fit: contain;
  position: relative;
  margin-bottom: 85/40rem;
  img {
    width: 100%;
    height: auto;
  }
}
.ca-avatar {
  position: absolute;
  width: 100/40rem;
  height: 100/40rem;
  bottom: -50/40rem;
  left: 50%;
  border-radius: 50%;
  background-color: #fff;
  border: solid 1px #fff;
  overflow: hidden;
  transform: translate(-50%, 0);
}
.select-type-container {
  height: 100%;
  background-color: #fff;
  .select-type-sa-info {
    text-align: center;
    margin-bottom: 90/40rem;
    .sa-name {
      font-weight: 500;
      font-size: 36/40rem;
    }
    .store-name {
      color: #909090;
      font-size: 22/40rem;
    }
  }
  .input-item {
    padding: 0 40/40rem;
    margin-bottom: 50/40rem;
    &-label {
      font-size: 22/40rem;
      margin-bottom: 12/40rem;
    }
    input {
      font-size: 24/40rem;
    }
  }
}
.next-step-container {
  position: fixed;
  bottom: 60/40rem;
  width: 100%;
  padding: 0 40/40rem 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .next-step-button {
    width: 100%;
  }
}
</style>
